module.exports = __webpack_public_path__ + "static/export3-min-1db463256e2ec008e4e378ad32acaed9.png";